var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.fileToLoad)?_c('img',{staticClass:"itemApprovalIcon",attrs:{"src":require(`@/assets/${_vm.fileToLoad}`)}}):_vm._e(),(_vm.isProof)?_c('img',{staticClass:"itemApprovalIcon",attrs:{"src":require(`@/assets/Proof.svg`)},on:{"click":_vm.cancelProof}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }